;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { TrackingDestination } from '@qogita/tracking'
import { browserLogger } from 'src/core/logger/browser'

import { SellersBrowserTrackingEventList } from '../../types'

const SIGN_UP_SUBMITTED_CONVERSION_ID = 15059634

function linkedinConversion(conversionId: number) {
  if (!window.lintrk) {
    browserLogger.warn('lintrk is not defined, skipping conversion', {
      conversionId,
    })
    return
  }
  window.lintrk('track', {
    conversion_id: conversionId,
  })
}

export const linkedinDestination =
  new TrackingDestination<SellersBrowserTrackingEventList>({
    eventHandlers: {
      'Sign Up Submitted': () => {
        linkedinConversion(SIGN_UP_SUBMITTED_CONVERSION_ID)
      },
    },
  })
